import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import logo from '../images/mokaunited-logo.svg';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Error signing out: ', error);
    }
  };

  const toggleDrawer = () => {
    setDrawerOpen(prev => !prev);
  };

  const menuItems = [
    { text: 'Form', path: '/form' },
    { text: 'All Users', path: '/users' },
    { text: 'Completed Users', path: '/completed' },
    { text: 'Incomplete Users', path: '/incomplete' },
    { text: 'Logout', action: handleLogout },
  ];

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="logo" />
        </Link>
        <div className="menu-icon" onClick={toggleDrawer}>
          {drawerOpen ? <FaTimes /> : <FaBars />}
        </div>
        <ul className={drawerOpen ? 'nav-menu active' : 'nav-menu'}>
          {menuItems.map((item) => (
            <li key={item.text} className="nav-item" onClick={() => {
              if (item.action) item.action();
              setDrawerOpen(false);
            }}>
              {'path' in item ? (
                <Link to={item.path} className="nav-links">
                  {item.text}
                </Link>
              ) : (
                <span className="nav-links">{item.text}</span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;